import * as React from 'react';
import {
  TooltipProvider as ShadcnTooltipProvider,
  TooltipTrigger as ShadcnTooltipTrigger,
  TooltipContent as ShadcnTooltipContent,
  Tooltip as ShadcnTooltip,
} from '@/hen-ui/shadcn/tooltip';

export interface TooltipProps
  extends Omit<
      React.ComponentPropsWithoutRef<typeof ShadcnTooltip>,
      'children'
    >,
    Omit<
      React.ComponentPropsWithoutRef<typeof ShadcnTooltipContent>,
      'children'
    > {
  content: string;
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export const Tooltip = ({
  content,
  children,
  side,
  ...props
}: TooltipProps) => {
  return (
    <ShadcnTooltipProvider>
      <ShadcnTooltip {...props}>
        <ShadcnTooltipTrigger asChild>{children}</ShadcnTooltipTrigger>
        <ShadcnTooltipContent side={side} {...props}>
          {content}
        </ShadcnTooltipContent>
      </ShadcnTooltip>
    </ShadcnTooltipProvider>
  );
};
